import { logClientError } from "@repo/next-utils/newrelic-client-utils";

type OnOpenParams = {
  isNewConversation: boolean | "None";
  userContext: {
    accessToken: string;
    customerId: string;
    isAuthenticated: boolean;
    firstName?: string;
    lastName?: string;
  };
};

export const onOpen = async ({
  isNewConversation,
  userContext,
}: OnOpenParams): Promise<void> => {
  if (!isNewConversation) {
    if (!window?.sierra) {
      const error = new Error("window.sierra is unavailable");
      logClientError({ error });
      throw error;
    }

    await window.sierra.updateSecrets({
      accessToken: userContext?.accessToken ?? "",
    });

    await window.sierra.updateVariables({
      customerId: userContext?.customerId ?? "",
      isAuthenticated: (userContext?.isAuthenticated ??
        false) as unknown as string,
      firstName: userContext?.firstName ?? "",
      lastName: userContext?.lastName ?? "",
    });

    if (userContext?.isAuthenticated) {
      window.sierra.sendUserAttachment([
        {
          type: "custom",
          data: {
            type: "user-logged-in",
          },
        },
      ]);
    }
  }
};
